module.exports = __webpack_public_path__ + "assets/img/PerspectiveProcess.82e185cd.svg";